import { Component, OnInit, ViewChild } from '@angular/core';
import { IDataQuery, ITableData, TableMobileComponent } from '@beego/ngx-table';
import { EventDetailsComponent } from '@internal-components/event-components/event-details-component/event-details.component';
import { EventsTableFactory } from '@internal-factories/tables/events-table.factory';
import { EventProvider } from '@internal-providers/event.provider';
import { LocationProvider } from '@internal-providers/location.provider';
import { NavigationType } from '@shared-libs/enums';
import { translate } from '@shared-libs/helpers';
import { UserDetailsManager } from '@shared-managers/user-details.manager';
import { ICalendarEvent } from '@shared-models/calendar-event.model';
import { IUserDetails } from '@shared-models/user.model';
import { CalendarEventProvider } from '@shared-providers/api/calendar-event.provider';
import { NavigationService } from '@shared-services/navigation.service';

@Component({
	selector: 'events-list-mobile-page',
	templateUrl: 'events-list.mobile.page.html',
	styleUrls: ['events-list.mobile.page.scss'],
})
export class EventsListMobilePage implements OnInit {
	@ViewChild('tableMobileComponent') tableMobileComponent!: TableMobileComponent;

	public events: Array<ICalendarEvent> = new Array();

	public locationOptions: Array<{ name: string; value: string }> = new Array();
	public ownEventsOptions: Array<{ name: string; value: boolean }>;
	public filterOpen: boolean = false;

	public ownEvents: boolean;
	public searchTerm: string;
	public locationId: string;
	public locationName: string;

	public readonly tableFilters = EventsTableFactory.getFilters();

	public userDetails: IUserDetails;

	constructor(
		private readonly calendarEventProvider: CalendarEventProvider,
		private readonly navigationService: NavigationService,
		private readonly eventProvider: EventProvider,
		private readonly locationProvider: LocationProvider,
		private readonly userDetailsManager: UserDetailsManager
	) {}

	public ngOnInit(): void {
		this.getOwnEventsOptions();
		this.getLocations();
		this.userDetailsManager.getUserDetails().subscribe((result: IUserDetails) => {
			this.userDetails = result;
		});
	}

	public readonly dataRequest = (_query: IDataQuery) => this.getEvents(_query);

	public async getEvents(_dataQuery: IDataQuery): Promise<ITableData<ICalendarEvent>> {
		return await this.calendarEventProvider.getAndCountAll(_dataQuery);
	}

	public dataChanged(_events: Array<ICalendarEvent>): void {
		this.events = _events;
	}

	public onSearchTermFilter(searchTerm: string): void {
		this.tableMobileComponent?.onExternalFilter('searchTerm', searchTerm);
		this.searchTerm = searchTerm;
		this.toggleFilter();
	}
	public onSearchTermFilterClick(): void {
		const searchTerm: string = (document.querySelector('._search-term-wrapper input') as HTMLInputElement).value;
		this.onSearchTermFilter(searchTerm);
	}

	public onLocationFilter(locationId: string): void {
		this.locationId = locationId;
		this.locationName = this.locationOptions.find((locationOption) => locationOption.value === locationId)?.name;

		this.tableMobileComponent?.onExternalFilter('Location.id', locationId);
		this.toggleFilter();
	}

	public onOwnEventsFilter(ownEvents: boolean): void {
		this.ownEvents = ownEvents;
		if (ownEvents) {
			this.tableMobileComponent?.onExternalFilter('Employee.id', this.userDetails.EmployeeId);
		} else {
			this.tableMobileComponent?.onRemoveExternalFilter('Employee.id');
		}
		this.toggleFilter();
	}

	public async onEventClick(calendarEvent): Promise<void> {
		const Event = await this.eventProvider.getOneForDay(calendarEvent.Event.id, calendarEvent.id);
		return this.navigationService.navigateTo(NavigationType.modal, EventDetailsComponent, {
			calendarEvent: calendarEvent,
			event: Event,
		});
	}

	public toggleFilter() {
		if (this.filterOpen) {
			this.filterOpen = false;
		} else {
			this.filterOpen = true;
		}
	}

	/**
	 * Get show beego options (yes/no)
	 * formatted for the calendar select filter
	 */
	private getOwnEventsOptions(): void {
		this.ownEventsOptions = [
			{ name: translate('FILTERS.OWN_EVENTS.OPTIONS.YES'), value: true },
			{ name: translate('FILTERS.OWN_EVENTS.OPTIONS.NO'), value: false },
		];
	}

	private async getLocations(): Promise<void> {
		this.locationOptions = (await this.locationProvider.getAll()).map((location) => ({
			name: location.place,
			value: location.id,
		}));
	}
}
